var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 62,
    viewBox: "0 0 55 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2843 0.861622C26.2742 -0.287207 28.7257 -0.287207 30.7156 0.861622L51.7843 13.0257C53.7741 14.1745 54.9999 16.2976 54.9999 18.5953V42.9233C54.9999 45.221 53.7741 47.3441 51.7843 48.493L30.7156 60.657C28.7257 61.8058 26.2742 61.8058 24.2843 60.657L3.21562 48.493C1.22579 47.3441 0 45.221 0 42.9233V18.5953C0 16.2976 1.22579 14.1745 3.21562 13.0257L24.2843 0.861622Z",
    fill: "#F3BE97",
    fillOpacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9028 12.8623H35.5849C41.7167 12.8623 45.8227 17.1672 45.8227 23.5703V38.3499C45.8227 44.7331 41.7167 49.038 35.5849 49.038H19.9028C13.771 49.038 9.64697 44.7331 9.64697 38.3499V23.5703C9.64697 17.1672 13.771 12.8623 19.9028 12.8623ZM26.7038 36.3584L35.2955 27.7667C35.9105 27.1517 35.9105 26.1569 35.2955 25.5238C34.6805 24.9088 33.6676 24.9088 33.0526 25.5238L25.5823 32.9941L22.417 29.8287C21.802 29.2137 20.7891 29.2137 20.1741 29.8287C19.5591 30.4437 19.5591 31.4385 20.1741 32.0716L24.479 36.3584C24.7865 36.6659 25.1844 36.8106 25.5823 36.8106C25.9984 36.8106 26.3963 36.6659 26.7038 36.3584Z",
    fill: "#254377"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.1562,
    y: 32.96,
    width: 7.05867,
    height: 7.05867,
    rx: 3.52934,
    fill: "#F47A1F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCheck);
export default __webpack_public_path__ + "static/media/step-check.af9f8209f91f5152700a0d0f7fc37168.svg";
export { ForwardRef as ReactComponent };